import { BaseModel } from './base';

import type { Images } from '../types/interfaces/images';

export class ServiceCategory extends BaseModel {
  id!: number;
  idServiceCategory!: number;
  name!: string;
  title!: string;
  information?: string;
  hasImage!: boolean;
  images?: Images;
  listOrder?: number;

  override objectID(): string {
    return this.idServiceCategory?.toString() || '';
  }

  get image(): string | null {
    if (this.hasImage) {
      return this.images?.square || null;
    }
    return null;
  }

  get initials(): string {
    return this.name?.charAt(0).toUpperCase() || '';
  }

  get description(): string {
    return this.title || '';
  }

  get label(): string {
    return this.name || '';
  }

  matchesQuery(query: string): boolean {
    if (this.name && this.name.toLowerCase().includes(query.toLowerCase())) {
      return true;
    }
    if (this.title && this.title.toLowerCase().includes(query.toLowerCase())) {
      return true;
    }
    return false;
  }
}